import { useFormikContext } from 'formik'
import { ThailandAddressType } from '@components/interfaces/AddressSearchSelect'
import { WriterFormType } from '@models/writer/WriterFormType'
import { DeliveryAddressProps, WithDeliveryAddressProps } from './interface'

export function withDeliveryAddress(Component: React.FC<DeliveryAddressProps>) {
  function WithDeliveryAddress({
    residenceOptions,
    countryOptions,
  }: WithDeliveryAddressProps) {
    const { values, setFieldValue } = useFormikContext<WriterFormType>()

    function handleAddressChange(data: ThailandAddressType) {
      setFieldValue('sendProvince', data.province)
      setFieldValue('sendDistrict', data.amphoe)
      setFieldValue('sendSubDistrict', data.district)
      setFieldValue('sendPostcode', String(data.zipcode))
    }

    const componentProps = {
      values,
      residenceOptions,
      countryOptions,
      handleAddressChange,
    }
    return <Component {...componentProps} />
  }

  return WithDeliveryAddress
}
